import React, { ChangeEvent, useEffect } from 'react';
import useTranslate from '~/hooks/useTranslate';
import Select from '~/components/shared/Select/Select';
import ValidationErrorMessage from '~/components/shared/ValidationErrorMessage/ValidationErrorMessage';
import { LoanPurposes } from '~/enums';
import InputField from '../Input/InputField';

interface LoanPurposeProps {
  loanPurposeHandler: (optionValue: LoanPurposes) => void;
  loanPurposeManualHandler: (info: ChangeEvent<HTMLInputElement>) => void;
  loanPurposeManual?: string;
  defaultValue?: string;
  value?: string;
  showLoanPurposeError?: boolean;
}

const LoanPurpose = ({
  loanPurposeHandler,
  loanPurposeManualHandler,
  loanPurposeManual,
  defaultValue,
  value,
  showLoanPurposeError,
}: LoanPurposeProps) => {
  const t = useTranslate();

  const loanPurposeOptions = [
    {
      label: t('LoanPurposeEquipment') as string,
      value: LoanPurposes.Equipment,
    },
    {
      label: t('LoanPurposeDebt') as string,
      value: LoanPurposes.RepayOtherLoan,
    },
    {
      label: t('LoanPurposeStaff') as string,
      value: LoanPurposes.Hiring,
    },
    {
      label: t('LoanPurposeMarketing') as string,
      value: LoanPurposes.Marketing,
    },
    {
      label: t('LoanPurposeInventory') as string,
      value: LoanPurposes.Inventory,
    },
    {
      label: t('LoanPurposeExpansion') as string,
      value: LoanPurposes.Expansion,
    },
    {
      label: t('LoanPurposeWorkingCapital') as string,
      value: LoanPurposes.Working,
    },
    {
      label: t('LoanPurposeOther') as string,
      value: LoanPurposes.Other,
    },
  ];

  const defaultOption = loanPurposeOptions.find(
    (l) => l.value === defaultValue
  );

  const selectedOption = loanPurposeOptions.find((l) => l.value === value);

  const otherPurposeReasonTextMaxCharLimit = 190;

  useEffect(() => {
    if (defaultValue) {
      loanPurposeHandler(defaultValue as LoanPurposes);
    }
  }, []);

  return (
    <>
      <div data-testid="loanPurposes">
        <Select
          name="LoanPurpose"
          validationType="LoanPurpose"
          options={loanPurposeOptions}
          placeholder={`- ${t('LoanPurpose')} - `}
          value={selectedOption}
          defaultValue={defaultOption}
          onChange={(loanPurpose) =>
            loanPurpose && loanPurposeHandler(loanPurpose.value)
          }
        />
      </div>
      {/* TODO: Create a shared component for all error messages */}
      {showLoanPurposeError && (
        <ValidationErrorMessage>
          {t('ApplyingLoan.LoanPurposeError')}
        </ValidationErrorMessage>
      )}
      {value === LoanPurposes.Other && (
        <InputField
          name="loanPurposeManualOther"
          value={loanPurposeManual}
          onChange={loanPurposeManualHandler}
          maxLength={otherPurposeReasonTextMaxCharLimit}
          characterCounter
          placeholder={t('AdditionalComments') as string}
          validationType="LoanPurpose"
        />
      )}

      {value !== LoanPurposes.Other && (
        <InputField
          name="loanPurposeManual"
          value={loanPurposeManual}
          onChange={loanPurposeManualHandler}
          maxLength={otherPurposeReasonTextMaxCharLimit}
          characterCounter
          placeholder={t('AdditionalComments') as string}
        />
      )}
    </>
  );
};

export default LoanPurpose;
